/** Тіло створення копії запису (прототип v4 «Копіювати вибране»): ті самі значення й теги, назва з позначкою копії. */
import type { IRecord, IRecordWrite } from '@platform/core/types';

/** Значення запису без порожніх, назва «<назва> (копія)», теги й видимість — як в оригіналу. Чиста функція. */
export function copyBody(record: IRecord, suffix: string): IRecordWrite {
  const values = Object.fromEntries(Object.entries(record.values).filter(([, v]) => v !== undefined && v !== null));
  return { values: { ...values, title: `${record.title} ${suffix}`.trim() }, tags: record.tags, visibility: record.visibility };
}
